import { Directive, HostListener, Input } from "@angular/core";
 
@Directive({
    selector: '[fallbackSrc]',
    standalone: false
})
export class FallbackSourceDirective {
  @Input()
  public source = "assets/images/cards/default_vertical.svg";
 
  @HostListener('error', ['$event'])
  public onSourceError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.src = this.source;
  }
}
 